import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PaginationService {
  currentPage: number = 0;
  currentScrollPage: number = 0;
  currentPageSize: number = 0;
  size: number = 10;

  from: number = 0;
  to: number = 0;

  totalElements: number = 0;
  totalPages: number = 0;

  leftNumbers: Array<number> = [];
  rightNumbers: Array<number> = [];

  public paginatingSubject: BehaviorSubject<number> = new BehaviorSubject(this.setPaginatingSubject);
  public scrollPaginatingSubject: BehaviorSubject<number> = new BehaviorSubject(this.setPaginatingSubject);

  constructor() {}

  public set setPaginatingSubject(page: number) {
    this.currentPage = page;
    this.paginatingSubject.next(page);
  }

  public set setScrollPaginatingSubject(page: number) {
    this.currentScrollPage = page;
    this.scrollPaginatingSubject.next(page);
  }

  paginationToString() {
    return (
      'current Page ' +
      this.currentPage +
      ' size: ' +
      this.size +
      ' currentPage: ' +
      this.currentPage +
      ' totalElement: ' +
      this.totalElements +
      ' totalPages: ' +
      this.totalPages
    );
  }

  setPaginationValues(paginatingObject: any) {
    this.initEnumeratedPagination({
      currentPageSize: paginatingObject.size,
      totalElements: paginatingObject.totalElements,
      totalPages: paginatingObject.totalPages,
    });
  }

  resetPageAndSize({ page = 0, size = 10 }) {
    this.currentPage = page;
    this.currentScrollPage = page;
    this.size = size;
  }

  /**
   * Summary. Init service
   * TODO. NG REDUX is a better solution for state management
   */
  init({ currentPageSize = 0, totalElements = 0, totalPages = 0 }) {
    if (totalElements) this.from = Math.round((totalElements / totalPages) * this.currentPage);
    if (totalElements) this.to = Math.round((totalElements / totalPages) * this.currentPage + 2);

    this.totalElements = totalElements;
    this.totalPages = totalPages;
    this.currentPageSize = currentPageSize;
  }

  initEnumeratedPagination({ currentPageSize = 0, totalElements = 0, totalPages = 0 }) {
    this.leftNumbers = [];
    this.rightNumbers = [];

    this.totalElements = totalElements;
    this.totalPages = totalPages;

    // Generate left pages (pages before current page)
    for (let i = Math.max(0, this.currentPage - 3); i < this.currentPage; i++) {
      this.leftNumbers.push(i);
    }

    // Generate right pages (pages after current page)
    for (let i = this.currentPage + 1; i < Math.min(this.totalPages, this.currentPage + 4); i++) {
      this.rightNumbers.push(i);
    }
  }

  next() {
    this.currentPage++;
  }

  previous() {
    this.currentPage--;
  }

  goToPage(page: number) {
    this.currentPage = page;
  }

  updatePagination(pagination: {
    currentPage: number;
    currentPageSize: number;
    totalElements: number;
    totalPages: number;
  }): void {
    this.currentPage = pagination.currentPage;
    this.currentPageSize = pagination.currentPageSize;
    this.totalElements = pagination.totalElements;
    this.totalPages = pagination.totalPages;

    // Update enumerated pagination after updating values
    this.initEnumeratedPagination({
      currentPageSize: this.currentPageSize,
      totalElements: this.totalElements,
      totalPages: this.totalPages,
    });
  }
}
